import $ from 'jquery'

class Range {
  constructor({ el, rootClass }) {
    this.$el = $(el)
    this.$input = $(el).find('input')
    this.$rangeValue = $(el).find(`${ rootClass }__range__value`)

    this.$input.on('input', e => {
      this.getValue()
      this.setColor(e.target.value)
    })
    this.getValue()
  }

  getValue() {
    let val
    if (this.$input.val() === '-1') {
      val = '-'
      this.$el.addClass('is-unSelected')
    } else {
      val = this.$input.val()
      this.$el.removeClass('is-unSelected')
    }
    this.$rangeValue.text(val)
  }

  setColor(value) {
    const baseColor = '#E6E6E6'
    const activeColor = '#4DA1FF'
    const max = this.$input.attr('max') ? Number(this.$input.attr('max')) : 100
    const min = this.$input.attr('min') ? Number(this.$input.attr('min')) : 0
    const range = Math.sign(min) === -1 ? Math.abs(max) + Math.abs(min) : Math.abs(max) - Math.abs(min)
    const shiftValue = Math.sign(min) === -1 ? Number(value) + Math.abs(min) : Number(value) - Math.abs(min)
    const progress = (shiftValue / range) * 100
    this.$input.css('background', `linear-gradient(to right, ${ activeColor } ${ progress }%, ${ baseColor } ${ progress }%)`)
  }
}

export default Range
